import * as yup from 'yup'

export const ENTRY_ID = '7mMUNFOjJepONypsDrXvBf'

export const fieldNames = ['userInvitationMethod']

export const validationSchema = yup.object().shape({
  userInvitationMethod: yup
    .string()
    .nullable()
    .required('Please make a selection.'),
})
